webpackJsonp([1],{

/***/ 127:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAQAAAE8DmCFAAAC+UlEQVRIx62Vy2sTURTGzyr/TJZnYivYRvGRtq4UggtdSMWltVRErdhFq/iIMhWCpT4pwY2valJNWwmh2IUrC2pAtFWpmyYiVFtFpeHnYm4mk8mrqPNtzhy++e65c14ioiiKOMY9WlFEiWD8SgvK3TJFUSQUVBRdEeUyCw7vIso7RDlY+rKS7IEoyjB5NrKLF2VXH8cMYxJFdMV5+cIU5TBzZR3L9gTlomhcSbaQ957YRwxlmVRlgMqol+Xgvte1wjWUK7zzsk6wxqbqD01kcRHRTFVsFYgGKm5TDx7xT6i5UphOTrtp8pAeohxAUTagzKAoJ/2k2yR4TcLgOQkS/PCTllB20E+aZ9yigNJFW3VM20hzC0UZp4s5b+CWvY7biUQDWqxPsOLiPJZdKggfcqGgiKPT+LCMiDQ6ykEoKM3D1pyH1EqeBTYzziOGa+cuwpD7+z6jLNYiJZnjK7tQNnKJzxzG9pNOoShZk16lGyXpJy2gKCOuO4bS6Sf98OQ+Yerhtp80jZr2d3AU5Yif1EYnSoExZknTz1ZTPL7bvWeCq8a+wR5WaalV43N08QBFuUqarbUbQdnEFGt84XhlWlbWkTvLFiu+jrqUxrRiNGAqMxqw4s3rqraIFXdlmgfV9GZxp0/4d1i21Gk3lDADZFmmSJFlsgwQri9VOyURXpEkQoI7rm+cMSKkeMmOZpOw3HgfOYRy3R3iDm5yDYtePlHwlFkdoTB5M0r3scwkH/jOT37ynQ9M8o29KEoHedobCz2l11jHPE1T3iml9dZnGquu0CpDDDLIILOkjFXGBLPGOs1qY6F5OtwhMFIV0SgXjNVllltdoZPumDlAtkpohv3GStHfLGuXeEKYYd7wm0nO0MN+uunhLNP84g027aS52Dz9ym4WOYfSQcGTmzB5tqOcZ5Gd66kjBy3EWOIJ86SI0MEEb3nMErEaFVQSyv2PXtOchIJ/OUAqhkko6KzBzD/JZNyJJCISClq25urPgup+15xlm5UsIn8A4TBExR9jzIQAAAAASUVORK5CYII="

/***/ }),

/***/ 128:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAAGWB6gOAAACnUlEQVRYw81YzUocQRAe8AXiI8xsbrIgbJuLIqJHvexhT8bkAbz5AHmGQC6Clyh4EREFQVDIEkGyJkFFwi4hOSrKBnZBEcQ9tF01P85M/850SywokLK36tv6r/W8iI4D8ttLU8uv0TTjC04YvwTihBkB0Hl1Yrjlk6bYQPzH5fLnrCBWnv1YUPsoBZuxHFp9EgLFNlLGSTP/ae6RyhSHCb3qk1UmvP3uj7318tQKyL5Iy+no1Ct88KNCxlXmODz/tvcykQgxkQEHmnuUdrfxozTFsuOg9kXrp8QFtNEYUj7Ik84lIQRyJFUgc7qOAak23VqVMXrxaUWYYRmElTd1yI01rVWNojAkAblxo+g1WXCiKGooR2UcLUwBKIkSStqeiiAKUB3iHIrS2JSgwrGHsGqHTgmVD43HWIGJvyD7pQoK+4hVAqdEVpCFldmEPvmaGCHJo1/19/Sh1xd2Kb5JSsIs62IixmjqoPcOvmoVQeG7UQQz24Ui6CBuFMFwd6EIByYUoTASc/M0T9frm+o2YpOQmYkCQ95JU4tQtYsqSfYDfraZI8vMM3lPEgcAyglnmA2BAjSgqE2hYfYZa+NJr7MIpmoLNHJvrnO3nQMRTERp8rhIbxuPlR6K0hYyMkE7C4u0826Rnk3X7YpeWQ0K7m7tUhHpVig5qHi9NtjVhLO1Okl/1maQ+4ffrAEhMyzCA6oox5PBGhCOIbaJvRhADIvwgP5fgHB1wOv0pQBiWMJLvcg4YHwyPku7GzsJ319eJYDuOn8S+d+lD0W22UGyvKuWUNPtRESyjUV6MBa9g5+LpVdIOFDL3ddljw6jQYsD9jmBMd3awar6ScP2WI7nlfJALEtYlazFhz9YkCb2MWiu0amLMvgfe1Po5I3oESKIKIyRa7ClAAAAAElFTkSuQmCC"

/***/ }),

/***/ 129:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAQAAAE8DmCFAAABFUlEQVRIx+VVQZKEIAzsk5/hmPAUn+FbuPAdn8EfvHO2eg64jqwiOLq1VbumLEiq7SSSBABCoRBfG6EQwoEDh7RdrW8IrBEKJWLzSXGzgJk5aDLFnQmQ8FbVZXEvMrfSUzht3va46ib1AGTcI7fSd1k2JUEdchU0kYfrw+7UNYCAvpO5DFCP9KjbF4RQKMEaIPGcOxsBnLlKYk1LduEHjuXJAx4O1wzEpey/r78Z+F1QbACpg/qGusQ5bO67pTL7Tn29ro5J1K809aCqmfnUJ7wv6lBot6sS8QhNa5X8EaKJzBqypheJBk5Z+9f0//izPycKjxAFWPPhAMmGiTXpGhxv0YzrRAIAa9RJuDALogR1y5UM4AV74O2Uy8Ed4gAAAABJRU5ErkJggg=="

/***/ }),

/***/ 130:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAAGWB6gOAAADN0lEQVRYw7VYS2tTQRQO+Af0JyQVBF8IuRYhLVYLKpRiSwlCqwVXCm4EwY1CcSXixoUbtS4a60YXgqCIggFpMElbk6bllvoEsbHSqGmagibRcc7ch/cxZ+5j0gMHwmTuN989zzk3EtElF1OWIlbJRuPEqmyHa9HYCeJatC2AlPZ0bctGlTT/AOOHgcUWlm+n/i/YHovFb6BkbSdrp2oLc0eSpNDdb+Orn6WkrQv1hUWS23GA/7aoWjkxq0aVCbq4no/uPxlxSjamPOehFPb1bGUbpjuUhOg4F58/jSYp371P5gdGLZyUpot0flcXmTt2gm9/px/QTVYx1nKx+EtPO5kmIMnkFuEGp3iZRKOgZFAAzOheCkw9w21DfWsaZPXRU5xhR+cgxEbK18lUlm9N4Makr1TzAvnbanH9aQfarpzC/qzNFBlAsXfIk7FRUDJhDM0NAUiJECBqRCTgBcgOfgzpYexXIMNZDaHZDpUSMh8Kj28AP/aC6EcBAtuIZoILBEvIwGAyrjdfk3mIVyF7jtuKz/Tegx5FEnFzY/U7+Xz9JikcGnBVMqcyb/qhvzL5UAgEie8LqFXfEANBz/YCKfUNM5CFodMi79WEQPnd3QykXlI9WNPmjrqVegmkUfnh+eqsYUISYhXRKe/OXxKXEZmAtHUUaPJtKWo6KzUoiHk/cPc2/8xs/QyvSXwHQDqxHiYjAMAOQHITPZg+I324WesknCm6Bfoyr6Nyq20nwumIaPC0I7xlLBa6KTq1eHiQvL8wxu5MHy9fJfP9I/JJL8wGji6OniPNtRoRSeXxsxCkjOu14K6GKQw/6shZ1/qvL2WT1Kexa8GtRbm4BigZrb56bRL6cPFKCAxoQ/Qm1g4y5fFJk0x1Khc2wNe5A3QQne08anPVSuqBTEdb0qbTEA/ndyZINZM3ifz++o28SfRJWRm4aJN6gHYwE+9lg7pV1nKzpPLkBfmZnmJxZKg6fCbIbbZpXt6xSyg3Vu7cI34Fu7GgA2PQOXizFJ1CtIYabr4OO3T4arSswW4mMYrt2VhFnzRkh2WjXwkHxLDCspKWeO2DhZJmdQyKqz7qsjX4j+4JNPLq8g+aTD862qaNDAAAAABJRU5ErkJggg=="

/***/ }),

/***/ 131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_scanner_download__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_css_style_css__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_css_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_css_style_css__);




window.isCdn = true;

new __WEBPACK_IMPORTED_MODULE_1_vue___default.a({
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_2__views_scanner_download__["a" /* default */]);
    }
}).$mount('#app');

/***/ }),

/***/ 333:
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(335);
exports = module.exports = __webpack_require__(334)(false);
// imports


// module
exports.push([module.i, ".download{height:100%;width:100%;max-width:1200px;margin:0 auto;background:url(" + escape(__webpack_require__(343)) + ") no-repeat 50%;background-size:cover;position:relative}.container{height:3.7rem;position:absolute;bottom:0;left:0;width:100%;background:url(" + escape(__webpack_require__(342)) + ") no-repeat 50%;background-size:cover}.container .content{margin-top:.4rem}.mask{width:100%;height:100%;background:rgba(0,0,0,.5);position:absolute;z-index:100;display:flex;justify-content:flex-end}.mask .arrow{margin-right:.18rem;width:.8rem}.arrow img{display:block;max-width:.8rem}.mask .info{margin-right:.14rem;margin-top:.5rem}.info .line{display:flex;height:.36rem}.info .line img{display:block;width:.36rem;height:.36rem;margin:0 .06rem}.info span{font-size:.36rem;color:#fff;line-height:.36rem;display:block}.content{display:flex;flex-direction:column;justify-content:center;align-items:center}.logo{width:3.6rem;height:1rem;display:block}.button{background:#c82133;border-radius:40px;width:3.2rem;height:.8rem;margin-top:.4rem}.button .btn-txt{font-size:.3rem;color:#fff;font-weight:700}.button .btn-icon{margin-left:.2rem}.button .btn-icon,.button .btn-icon img{width:.32rem;height:.32rem}.flex{display:flex}.jc-c{justify-content:center}.ai-c{align-items:center}.ml10{margin-left:.1rem}", ""]);

// exports


/***/ }),

/***/ 336:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 341:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFcAAAB+CAQAAAGMZXWPAAAFIUlEQVR42u2ca2wUVRTHz2x3gTbSQikgCPKoVVMpURqIrW2sWiOIID6oBjVG8VUlKWgbY2zVD4qJbVCCBBPARE0TE7AaQ6rRaKMhJRgiUSlfDK0vYvABhqaawO7+/LDT7XaZ3Z2ZvdPOwj1fZubOuf/7n7Nnzj33MSuiQIxzi0ABLg8lXnSJiHC1CEczVoy3zv1WtyutCsutCvNHXwZ4RcZXQCRgfStgHyTfpl5VckG9eWzmKyv9zaMvV5jHG90+7C2S28IA0OtzjrtEeNzjNuYrxIrGzzbwvjLUjkwKJRSKFs88pJkvHQTBWIS3EfH4WESEu3PMGmc8Q079xjBbxDKsW6heltzVcp29ikVp+ixOJWmvExHhQQ+ssFKEfrtdZ5TrjYWpkNqcNVzGYcc5EoaT7n61Pcw7HSQcmZWeEaHJjuILOtRp8U+cjUnQaQKdHnRm/J05qxRYIgmNTMgZG1fQl2tekWN893ODm2oRXhQR4SZ2pu5mnABuSuxTE8pDSdcvs8o+6MT07kMUs2+mkCu8se/DTpSPMy+DRmUsByDslT9YxhsjncMb6e7uliH5U542prrlMz1FeZeax30PaBLhXeABhtTb8x9+UQtYDexQ3ZMdUANUTCeFImzMFmgaW2gXYQ27mKVzDS1atOROUhUF5Uk2+wFU9yaTzGEMakcbf8Qb6MyQP7hNrg1DHdsf42d9F7bfnmaqF7DoiBAcWXpQ57ciy+VzbdtR7hUYXy6PUCHC27zJAnWgTRygVITpbGTSyEpqgsZcZ4D5DFqUnuBYVi8uWA+iqU0OM+pMU+au2gAz09ydk7BOaH+OnmmZ7DUyxeFJSKSAVpVw5Z7E+pgGd/CGE3/NODLnO9MFQ56Eb7VwbeRR4LxaN+2ZLAtc7hw4rXV5VoQNbh+1LkX5XKqzsWCXlaMBpHuxnUQy4oB1PO9vdzJB7wKWqYc1VAMeUhz8Ym8S69WCfgTUqIObxa98o5LfOn4XEeFaNXBL2Cciwmcjy/PZwK2N7VziGPepfOhubtazC1q0aNGiRct5IYY/aXGVVMuA9BgR31uQpUSHJ/Jp9jvZBkbLPX4m+xznyjK/km3FSs6MjIkDvuI72bI0JNf4NDIwWdbKIimUEpkjITEkLAelzfhLh3ClVn6HTiWzOGNCtgisJtNFgr7kG5Z6nzI7Hzz3Q/YyI1fIlgE/Wd/zo4cclyrRC8neuEIF/WxLdTfgO75PyAL5OXesO4GlLlZ7XDS0kwjA8LfP9JgJ4Ao/WSPAEvOsgOI0eosJsy/9fhSCnOZE8ndh6qiW0Av8bS/f5xJ6iYz67jxZ4yVgq5e2fUxt3kTIm9XUCia6rlvDST4ZS39tAQ7jOgjyNfBUUtl64AsvyM7mLfYqxpxHlCEuuuA7yddpz/b1oggSd7+o/LY9OTLC2WzXbmmAYXciwBGg0Ru6IZ7kXqWIdRz14uvfHPXdAK38kK67zVB/ETDIFAz2EM368w4bDVYSJuLuzz+Ywn9EWMjF/EuY5WNl4fJcdIxLGWSIDnuBjc3sYBA4wvgNCljMHlrM8zVsp5Ha4b/XII8ybqOFGawmQpRPudVP1q5iE7s5OEyKbfTTzRZqRVxs2xpz+vPp5ZSSDSJjQLYR+MCT/ezKKBo00MeVuWHP24HfeJQ8vxIspYOToGhHVEYJuvnBpUaCRo+IiJRKsdQb3/rOJ+MjiSgwwKs+/cH53pzcWOVPeq+Z9Lb6k95Kk94hnRxr0aJFi5Ycl/8BEVke+DEUiSwAAAAASUVORK5CYII="

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/backgroung1.3168c81.png";

/***/ }),

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/backgroung2.94ad41c.jpg";

/***/ }),

/***/ 344:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAAEEfUpiAAAAAXNSR0IArs4c6QAAA/tJREFUWAmdl79rVEEQx3Mpki6VSBAJQTshqVLYBoQgiCLE/v6BxP8h/4BVYhEbCxsbQRLbhwjGzkIjBo0nBoJtSCpDeH4/+3b2ZvfeXX4MzO38+M7svn2zs+/GxiLVdX1schhlOEMYd57xDIEi5/VglLAuXjKlDkKDqDso8prxhVf6sgDzoEQzMWIFBRkUEwRH1C1dyMDa3oofRWeXsZVIGWnThAwo44R4T1xlDpQYsW+OqB8EXcqJeC4Cuw50LPt0/1nlkWHHAIzS67TDKLJd03Ag/pqA0RF0ZNGpOVFIsybumdHG4HTKDgbRlng3SCywJDkmxTzVKFor41gGgUZhSwZA0SBQLwKbHZHCG4DSRluwbGHpptsou8UcsY1fcHQ6ndsO8FKg7BmlvxIHjLD/hH0nnmL5lTiVGEmkdrEVlLY/YsJmIhMQKCjuR8Zl8WdnCqJsT0NAXW8knwxUAEQNTSSHE2RfBRApe8QEk3NafGSoYuzPmCJaBAUtiSsxq+GMcCxbV5WFC0RZjiKKbDILMkUO2wMSrJidUfqMeB9HpLzYZAwFo3HgUBSJ5iyDxmYlEtg0KO+PzcxnsneHJDkJdgFsxwc2iayirAsQJJs9zgSlPIUxlifiRWgxgp5ZS9m2KGW/JX5uOqP0WfFrs2myP1G+hxPaNKfk78FS1z/j+CuO5XnBfGwJdi0BoxxsXknLBQZ/ZQmy7C1JnhTBdiaWSLARp1r1oJjkh3z3W+whJNljAobm0kueQUGYHkDRWvJKsWLCMbASgLLTxjhcUHOvpAwNwCcBRMfhKqOVexooLJ/H74kPQqZi25tIlqFQCBKz0VbyEs8lsMScO2H4jCjm5CkIfCO+W/qi/k3jb/Fh1G9onBXfiXo5fJLhsU7A39KR6Uws9n1Janhx1N3AYc+CnQJWTIy9dImByN2+K3KU3bQn28iylH8WdnMPiOQQ98Se+iVMhDx2mAzUWso+u4CVgZG9r00Wxk6vhTUXlDQuIE/ZddCWDJsC7BYgdvTRiEmEKxcRWklFhkhZUxs2+VUXEOPs84wpK/r5gpvoo5OTKOCHuEAG2vTN5IyCbLfFvoDfl5io+zkW2ErufaOttiA5+cRpa/EWV46nMjwYkmvbgfdYAB8dntL/gjKBQF3xqIUwcXZ1+Bzy8XnhaZ0FcGZ9l9vH5gNLWf5yIUycXXgtMcxDbiPmbOaRQAPiq8mIBpJ//JQZL6GTS+ybEnPlDUmGSbE/WlJDA7nyQhTPxD2xJ+aYHLp+OefFvpotmO3jj+SoGuEdg/FbLTUQOS/+MAKzI7Rn/2qkXoqIJcfQJ269Ddu2R0komEXxQzG3HjcgDB1G5pbkD3R10Q/N/0H13dQpwkseAAAAAElFTkSuQmCC"

/***/ }),

/***/ 345:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo2.5d3efa5.png";

/***/ }),

/***/ 346:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo3.673bb35.png";

/***/ }),

/***/ 347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(92);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_153dc06c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(349);
function injectStyle (ssrContext) {
  __webpack_require__(350)
}
var normalizeComponent = __webpack_require__(348)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_153dc06c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 349:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.contentVisible)?_c('div',{staticClass:"download"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.mask),expression:"mask"}],staticClass:"mask"},[(_vm.lang === 'cn')?_c('div',{staticClass:"info"},[_vm._m(0),_vm._v(" "),_vm._m(1)]):_c('div',{staticClass:"info"},[_vm._m(2),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_vm._m(4)]),_vm._v(" "),_c('div',{staticClass:"container flex jc-c ai-c"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"info"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.logo,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"button flex jc-c ai-c",on:{"click":_vm.jump}},[_c('span',{staticClass:"btn-txt"},[_vm._v(_vm._s(_vm.btnTxt))]),_vm._v(" "),_c('img',{staticClass:"btn-icon",attrs:{"src":__webpack_require__(344),"alt":""}})])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line"},[_c('img',{attrs:{"src":__webpack_require__(128),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"ml10"},[_vm._v("点击")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(129),"alt":""}}),_vm._v(" "),_c('span',[_vm._v("右上角的按钮")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line",staticStyle:{"margin-top":"0.1rem"}},[_c('img',{attrs:{"src":__webpack_require__(130),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"ml10"},[_vm._v("选择")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(127),"alt":""}}),_vm._v(" "),_c('span',[_vm._v("在浏览器打开")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line"},[_c('img',{attrs:{"src":__webpack_require__(128),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"ml10"},[_vm._v("Tap")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(129),"alt":""}}),_vm._v(" "),_c('span',[_vm._v("icon in the top right corner")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line",staticStyle:{"margin-top":"0.1rem"}},[_c('img',{attrs:{"src":__webpack_require__(130),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"ml10"},[_vm._v("Click")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(127),"alt":""}}),_vm._v(" "),_c('span',[_vm._v("Open in browser")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"arrow"},[_c('img',{attrs:{"src":__webpack_require__(341),"alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(333);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(351)("15c09510", content, true, {});

/***/ }),

/***/ 355:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(132);
__webpack_require__(91);
module.exports = __webpack_require__(131);


/***/ }),

/***/ 92:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      device: 1,
      mask: false,
      logo: '',
      lang: 'en',
      query: '',
      contentVisible: false
    };
  },
  created: function created() {
    this.lang = this.checkLanguage();
    if (this.lang === 'cn') {
      this.logo = __webpack_require__(346);
    } else {
      this.logo = __webpack_require__(345);
    }
    var query = {};
    var queryArray = window.location.search.substr(1).split('&');
    if (queryArray && queryArray.length) {
      queryArray.forEach(function (i) {
        var params = i.split('=');
        query[params[0]] = params[1];
      });
    }
    this.query = query.r;
    if (document.body.offsetWidth > 1024) {
      this.buriedPoint(4);
      var url = '';
      var origin = '';
      if (window.isCdn) {
        origin = 'https://scanner.hithink.com';
      } else {
        origin = 'https://scanner.myhithink.com';
      }
      window.location.href = this.query ? origin + '?r=' + this.query + '#/download' : origin + '/#/download';
      return;
    } else {
      this.contentVisible = true;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      document.title = _this.lang === 'cn' ? '口袋扫描仪-专业扫描&识别文档' : 'Scanner HD | Scan your documents anywhere anytime';
      var head = document.getElementsByTagName('head');
      var meta = document.createElement('meta');
      var meta2 = document.createElement('meta');
      meta.name = 'description';
      meta.content = _this.lang === 'cn' ? '一键将文档、纸、名片等转成PDF、png，现在下载免费送OCR~' : 'Finish your works easily with an automatic process including detect, scan and extracted recognition (OCR)  technology.';

      meta2.setAttribute('property', 'og:description');
      meta2.content = _this.lang === 'cn' ? '一键将文档、纸、名片等转成PDF、png，现在下载免费送OCR~' : 'Finish your works easily with an automatic process including detect, scan and extracted recognition (OCR)  technology.';
      head[0].appendChild(meta2);
      head[0].appendChild(meta);
    });
    this.checkDevice();
  },

  computed: {
    btnTxt: function btnTxt() {
      if (this.lang === 'cn') {
        return '立刻下载';
      } else {
        return 'Get it Now';
      }
    }
  },
  methods: {
    checkDevice: function checkDevice() {
      var userAgent = navigator.userAgent;
      if (userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1) {
        this.device = 1;
      } else if (!!userAgent.match(/(?:iPhone)/) || !!userAgent.match(/(?:iPad)/) || !!userAgent.match(/(?:Mac)/)) {
        this.device = 2;
      } else {
        this.device = 1;
      }
    },
    checkWeChat: function checkWeChat() {
      var userAgent = navigator.userAgent;
      if (/MicroMessenger/i.test(userAgent)) {
        return true;
      }
      return false;
    },
    checkPhoneBrand: function checkPhoneBrand() {
      var ua = navigator.userAgent.split("(")[1].split(")")[0];
      var brand = "";
      var phone = [/IPHONE/gi, /huawei|honor|hdh60-l01|dub/gi, /mi|MI|Redmi|HM|kot49h|mmb/gi, /vivo/gi, /OPPO/gi, /samsung/gi, /SONY/gi, /Nokia/gi, /HTC/gi, /ZTE/gi, /Lenovo/gi, /ZUK/gi];
      if (phone[0].test(ua)) {
        brand = "iPhone";
      } else if (phone[1].test(ua)) {
        brand = "huawei";
      } else if (phone[2].test(ua)) {
        brand = "xiaomi";
      } else if (phone[3].test(ua)) {
        brand = "vivo";
      } else if (phone[4].test(ua)) {
        brand = "OPPO";
      } else if (phone[5].test(ua)) {
        brand = "SAMSUNG";
      } else if (phone[6].test(ua)) {
        brand = "SONY";
      } else if (phone[7].test(ua)) {
        brand = "Nokia";
      } else if (phone[8].test(ua)) {
        brand = "HTC";
      } else if (phone[9].test(ua)) {
        brand = "ZTE";
      } else if (phone[10].test(ua) || phone[11].test(ua)) {
        brand = "Lenovo";
      } else {
        brand = "Android";
      }
      console.log(brand, 'phone brand');
      return brand;
    },
    checkLanguage: function checkLanguage() {
      var lang = localStorage.getItem('localeLanguage') || (navigator.language || navigator.browserLanguage).toLowerCase();
      if (lang.indexOf('cn') > -1) {
        return 'cn';
      } else {
        return 'en';
      }
    },
    jump: function jump() {
      var href = '';
      var isWeChat = this.checkWeChat();
      if (isWeChat) {
        location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.hithink.scannerhd';
        return;
      }
      if (this.device === 1) {
        if (this.lang === 'cn') {
          this.buriedPoint(1);
          this.downloadWithQuery();
        } else {
          this.buriedPoint(2);

          location.href = 'https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=com.hithink.scannerhd&ddl=1&pcampaignid=web_ddl_1';
        }
      } else {
        this.iosDownload();
        this.buriedPoint(3);
      }
    },
    buriedPoint: function buriedPoint(type) {
      window.gtag('event', 'aH5Down', { 'to': type });
    },
    downloadWithQuery: function downloadWithQuery() {
      var url = '';
      var query = this.query;
      var brand = this.checkPhoneBrand();
      if (brand === 'huawei') {
        url = 'appmarket://details?id=com.hithink.scannerhd';
        setTimeout(function () {
          location.href = 'https://appstore.huawei.com/app/C100895715';
        }, 3000);
      } else if (brand === 'xaiomi') {
        url = 'mimarket://details?id=com.hithink.scannerhd';
        setTimeout(function () {
          location.href = 'http://app.mi.com/details?id=com.hithink.scannerhd&ref=search	';
        }, 3000);
      } else if (query) {
        url = window.isCdn ? 'https://d7evxxtys43ia.cloudfront.net/install/android/' + query + '/scannerHD.apk?t=' + Date.parse(new Date()) : 'https://myhithink.com/install/android/' + query + '/scannerHD.apk?t=' + Date.parse(new Date());
      } else {
        url = window.isCdn ? 'https://d7evxxtys43ia.cloudfront.net/install/android/scannerHD.apk?t=' + Date.parse(new Date()) : 'https://myhithink.com/install/android/scannerHD.apk?t=' + Date.parse(new Date());
      }
      console.log('apk url', brand, url);
      location.href = url;
    },
    iosDownload: function iosDownload() {
      var query = this.query;
      if (query) {
        location.href = 'https://itunes.apple.com/app/apple-store/id1457649898?pt=464212&ct=' + query + '&mt=8';
      } else {
        location.href = this.lang === 'cn' ? 'https://itunes.apple.com/cn/app/scanner-hd/id1457649898?mt=8' : 'https://itunes.apple.com/app/scanner-hd/id1457649898?mt=8';
      }
    }
  }
});

/***/ })

},[355]);


// WEBPACK FOOTER //
// static/js/app.18008f0aa06ccad18259.js